module.exports = __webpack_public_path__ + "img/img19.b44e7a3f.jpg";